import React from 'react';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

/**
 * Standard pagination footer used across every paginated list view.
 * Hidden when there's only one page. First/Last jump buttons appear once
 * the dataset spans 4+ pages — useful for deep navigation without
 * spamming Next.
 */
export const Pagination = ({ page, pageSize, total, onPageChange, testIdPrefix = 'pagination' }) => {
  const pages = Math.max(1, Math.ceil((total || 0) / (pageSize || 1)));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total || 0);
  const showFirstLast = pages >= 4;
  return (
    <div className="flex items-center justify-between text-sm text-muted-foreground gap-4 pt-2 pb-1">
      <div data-testid={`${testIdPrefix}-summary`}>
        Showing <strong>{start}–{end}</strong> of <strong>{total ?? 0}</strong>
      </div>
      {pages > 1 && (
        <div className="flex items-center gap-2">
          {showFirstLast && (
            <Button
              variant="outline"
              size="sm"
              disabled={page <= 1}
              onClick={() => onPageChange(1)}
              title="First page"
              data-testid={`${testIdPrefix}-first`}
            >
              <ChevronsLeft className="h-3.5 w-3.5" />
            </Button>
          )}
          <Button
            variant="outline"
            size="sm"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
            data-testid={`${testIdPrefix}-prev`}
          >
            <ChevronLeft className="h-3.5 w-3.5" /> Prev
          </Button>
          <span className="text-xs">Page <strong>{page}</strong> of <strong>{pages}</strong></span>
          <Button
            variant="outline"
            size="sm"
            disabled={page >= pages}
            onClick={() => onPageChange(page + 1)}
            data-testid={`${testIdPrefix}-next`}
          >
            Next <ChevronRight className="h-3.5 w-3.5" />
          </Button>
          {showFirstLast && (
            <Button
              variant="outline"
              size="sm"
              disabled={page >= pages}
              onClick={() => onPageChange(pages)}
              title="Last page"
              data-testid={`${testIdPrefix}-last`}
            >
              <ChevronsRight className="h-3.5 w-3.5" />
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
